import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import BetTableTeen33 from "../../casinoComponents/betTableTeen33";
import VideoBox from "../../casinoComponents/videoBox";
import Teen20RefCardsOverlay from "../../casinoComponents/videoBox/overlays/Teen20RefCardsOverlay";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import MyBet from "../../casinoComponents/myBet";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ResultTeenInstant from "../resultui/resultTeenInstant/ResultTeenInstant";
import { getCasinoGameDetails, getMatchExposure, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import ViewMoreModal from "../../../components/ViewMoreModal";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatMainNation } from "../../../utils/casinoMyBets";
import "../../../styles/games/teen33.css";

const REMARK_ICON = `${import.meta.env.BASE_URL}assets/img/icons/remark.png`;

/**
 * Instant Teenpatti pages — casino/teen3 ("Instant Teenpatti"), casino/teen32 ("Instant Teenpatti 2.0"),
 * casino/teen33 ("Instant Teenpatti 3.0"). Reference markup (.casino-table.teenpatti1day): no .game-header;
 * .casino-video starts with .casino-video-title (name + round id), card overlay A=[0,2,4] / B=[1,3,5]
 * without player headings; .casino-detail (only once a round id is known) = bet table, remark marquee,
 * Last Result.
 */
export default function TeenInstantPage({ defaultType, title }) {
  const [gameData, setGameData] = useState(null);
  const [iframeSrc, setIframeSrc] = useState("");
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [subData, setSubData] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  
  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || defaultType;

  useEffect(() => {
    const name = extractCasinoGame(pathname) || defaultType;
    setIframeSrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
        setSubData(response?.data?.data?.sub || []);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname, defaultType]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId =
        gameData?.data?.data?.t1?.gmid?.toString() ||
        gameData?.data?.data?.mid?.toString() ||
        gameData?.data?.mid?.toString() ||
        gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              exposureMap[teamName] = exposureAmount;
              exposureMap[teamName.toLowerCase()] = exposureAmount;
              exposureMap[teamName.trim()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [
    gameData?.data?.data?.t1?.gmid,
    gameData?.data?.data?.mid,
    gameData?.data?.mid,
    gameData?.mid,
  ]);

  const fetchMyBetsData = useCallback(async () => {
    const name = extractCasinoGame(pathname) || defaultType;
    if (!name) return;
    try {
      const response = await getCasinoOpenBets(name);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [pathname, defaultType]);

  useEffect(() => {
    const matchId =
      gameData?.data?.data?.t1?.gmid?.toString() ||
      gameData?.data?.data?.mid?.toString() ||
      gameData?.data?.mid?.toString() ||
      gameData?.mid?.toString();

    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [fetchExposure, gameData]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const roundId =
    gameData?.data?.data?.t1?.gmid ||
    gameData?.data?.data?.mid ||
    gameData?.data?.mid ||
    gameData?.mid ||
    "";
  const remark = gameData?.data?.data?.remark ?? gameData?.data?.remark ?? "";
  const cards = gameData?.data?.data?.card ?? gameData?.data?.card;

  return (
    <CasinoTableLayout
      tableClass="teenpatti1day"
      rightSide={<MyBet bets={myBets} formatNation={formatMainNation} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <VideoBox
        iframeSrc={iframeSrc}
        timerValue={gameData?.data?.data?.lt}
        gameType={gameName}
        titleNode={
          <div className="casino-video-title">
            <span className="casino-name">{title}</span>{" "}
            <span className="casino-video-rid">Round ID: {roundId}</span>
          </div>
        }
        cardsOverlay={cards ? <Teen20RefCardsOverlay cards={cards} showNames={false} /> : null}
      />
      {roundId ? (
        <div className="casino-detail">
          <BetTableTeen33
            data={subData}
            onBetClick={handleBetClick}
            exposures={exposures}
            myBets={myBets}
          />{" "}
          {remark !== "" && (
            <div className="casino-remark mt-3">
              <div className="remark-icon">
                <img src={REMARK_ICON} alt="" />
              </div>{" "}
              <marquee>{remark}</marquee>
            </div>
          )}{" "}
          <CasinoLastResult
            gameType={gameName}
            resultComponent={<ResultTeenInstant gameType={gameName} title={title} roundId={roundId} />}
          />
        </div>
      ) : null}
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatMainNation}
      />
    </CasinoTableLayout>
  );
}
